import { Field, ErrorMessage } from 'formik';
import Cleave from 'cleave.js/react';
import { FormGroup, Label, FormFeedback } from 'reactstrap';
import React from 'react';

interface Props {
   name: string;
   label?: string;
   placeholder?: string;
   className?: string;
   style?: React.CSSProperties;
}

export const FormikCurrencyInput: React.FC<Props> = ({
   name,
   label,
   placeholder = '$0',
   className = '',
   style,
}) => {
   return (
      <FormGroup className="mb-3">
         {label && (
            <Label
               for={name}
               style={{ display: 'flex', alignItems: 'center', gap: '0.25rem' }}
            >
               {label}
            </Label>
         )}

         <Field name={name}>
            {({ field, meta, form }: { field: any; meta: any; form: any }) => (
               <>
                  <Cleave
                     {...field}
                     id={name}
                     className={`form-control ${className} ${meta.touched && meta.error ? 'is-invalid' : ''}`}
                     style={style}
                     options={{
                        prefix: '$ ',
                        numeral: true,
                        numeralThousandsGroupStyle: 'thousand',
                        numeralDecimalScale: 0,
                        numeralPositiveOnly: false,
                     }}
                     placeholder={placeholder}
                     onBlur={(e) => {
                        let rawValue = e.target.value.replace(/[^0-9-]/g, '');
                        const numericValue = rawValue ? Number(rawValue) : 0;
                        form.setFieldValue(name, numericValue);
                     }}
                     onFocus={(e) => {
                        const target = e.target;
                        setTimeout(() => {
                           if (target.value.startsWith('$ ')) {
                              target.setSelectionRange(2, target.value.length);
                           } else {
                              target.select();
                           }
                        }, 0);
                     }}
                     autoComplete="off"
                     inputMode="numeric"
                  />
                  <FormFeedback>
                     <ErrorMessage name={name} />
                  </FormFeedback>
               </>
            )}
         </Field>
      </FormGroup>
   );
};
